if(document.querySelector('.variant-input-wrap[name="Size"]')){
  document.querySelector('.variant-input-wrap[name="Size"]').onchange = function() {
    var selectedSize = document.querySelector('.variant-input-wrap[name="Size"] input[type=radio]:checked');
    let allSwatches = document.querySelectorAll('.swatch-groups-list-item');
    let soldOutSwatches = document.querySelectorAll('[data-sold-out-' + selectedSize.value + '] .swatch-groups-list-item');
  
    for (var i = 0; i < allSwatches.length; ++i) {
       allSwatches[i].classList.remove('soldout');
    }
    for (var i = 0; i < soldOutSwatches.length; ++i) {
       soldOutSwatches[i].classList.add('soldout');
    }
    console.log(selectedSize.value);
  };
}

document.addEventListener("DOMContentLoaded", function(event) {
  window.dataLayer = window.dataLayer || [];
  var form = document.getElementById("newsletter-footer");
  form.addEventListener("submit", function(e){
    //    e.preventDefault();    
    console.log('custom evente "email_signup" Start')
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'email_signup',  
            'tbx-action': 'Email Signup'         
        });
    console.log('custom evente "email_signup" End')
  });
});


document.addEventListener('variant:change', function(evt) {
  console.log(evt.detail.variant.id);
  document.querySelector('#BIS_trigger').setAttribute("data-variant-id", evt.detail.variant.id);
});


document.querySelectorAll(".product-main-slide").forEach((item, index) => { 
  item.addEventListener('mouseover', arrow => {
    let selectedSlide = document.querySelector(".product-main-slide.is-selected");
    if (selectedSlide) {
      selectedSlide.classList.remove("is-selected");
    }
    item.classList.add("is-selected");
  })
})

document.querySelectorAll(".product-main-slide").forEach((item, index) => { 
  item.addEventListener('mouseout', arrow => {
    item.classList.remove("is-selected");
  })
})

document.querySelectorAll('[data-video-type="mp4"]:has(.product-video-trigger--mp4)').forEach((item, index) => { 
  item.addEventListener('click', arrow => {
    let selectedVideo = item.querySelector('.product__video');
    if (selectedVideo) {
      selectedVideo.play();
    }
    item.querySelector('.product-video-trigger--mp4').classList.add("hide");
  })
})

document.addEventListener('ajaxProduct:added', function(evt) {
  let cartProductDetail = evt.detail.product;
  if (cartProductDetail) {
    let hasTariff = cartProductDetail.properties.hasOwnProperty('_tariff');
    if (hasTariff) {
      setTimeout(function() {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {}
        }));
      }, 1500);
    }
  }
});

document.addEventListener('cart:updated', function(evt) {
  let cartContents = evt.detail.cart.items;
  if (cartContents) {
    if (cartContents.length > 1) {
      cartContents.forEach((item, index) => {
        let hasTariff = item.properties.hasOwnProperty('_tariff');
        if (hasTariff) {
          setTimeout(function() {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {}
            }));
          }, 1500);
        }
      });
    } else {
      cartContents.forEach((item, index) => {
        let isTariff = item.handle.includes("tariff");
        if (isTariff) {
          setTimeout(function() {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {}
            }));
          }, 1500);
        }
      });
    }
  }
});
